import baseClasses from '@components/Themes/layout.module.scss'
import axios from 'axios'
import JoinUsmodulescss from 'dist/css/JoinUs.module.scss'
import React, { FunctionComponent } from 'react'
import _server from 'react-dom/server'

import TopPageJoinUs from '@components/TopPageJoinUs'
import { Close } from '@mui/icons-material'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Hidden from '@mui/material/Hidden'
import Snackbar from '@mui/material/Snackbar'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { addContacts, editContacts } from '@store/actions/contactsActions'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { useDispatch } from 'react-redux'
import { NavLink } from 'react-router-dom'
import YouTube from 'react-youtube'
import 'swiper/css/bundle'
import 'swiper/css/free-mode'
import 'swiper/css/pagination'

const JoinUs: FunctionComponent = (props: any) => {
  const {
    history: navigation,
    match: { params },
  } = props
  const classes = baseClasses
  const initialDataContacts = {
    Name: '',
    LastName: '',
    Email: '',
    Subject: '',
    Message: '',
  }
  const [Contactsdata, setContactsdata] = React.useState<any>(initialDataContacts)
  const handleContactsChange = (name: string) => (event: any) => {
    return new Promise((resolve, reject) => {
      const value = event?.target ? (event.target.files ? event.target.files[0] : event.currentTarget?.value || event.target.value) : event
      if (value !== Contactsdata[name]) {
        setContactsdata((oldValues) => {
          return {
            ...oldValues,
            [name]: value,
          }
        })
      }
      resolve(value)
    })
  }
  const [messageSent, setmessageSent] = React.useState<any>(false)
  const [errorMessage, seterrorMessage] = React.useState<any>('')
  const sendEmail = (to, extra: any = {}) => {
    const from = extra.from || 'RealTravel Team <cofran@aptugo.com>'
    const subject = extra.subject || 'Website Real Travel - Nuevo mensaje de contacto'
    const messageHtml = contact(extra)
    axios({
      method: 'POST',
              url: 'https://www.realtravelapp.com/api/sendEmail',
      data: {
        name: from,
        email: to,
        messageHtml: messageHtml,
        extra: extra,
        subject: subject,
      },
    })
      .then((response) => {
        if (response.data.msg === 'success') {
          console.log('Email sent, awesome!')
        } else if (response.data.msg === 'fail') {
          console.log('error', response)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
  const theme = { ...baseClasses, ...JoinUsmodulescss }
  function contact(emailParameters: any = {}) {
    var _server2 = _interopRequireDefault(_server)
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj }
    }

    function renderEmail(emailComponent) {
      var doctype = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
      return `${doctype}${_server2.default.renderToStaticMarkup(emailComponent).replaceAll('/img/', 'https://www.realtravelapp.com/img/')}`
    }

    return (
      emailParameters.content ||
      renderEmail(
        <div>
          <div
            data-title="Email structures Validate account"
            className={theme.emailStructures}
            style={{
              background: '#FAF9F9',
              width: 'clamp(22.5rem, 9.134rem + 59.4vw, 62.598rem)',
              padding: '1.25rem clamp(0rem, -3.933rem + 17.48vw, 11.799rem) 3.75rem',
              fontFamily: 'Montserrat, sans-serif',
            }}
          >
            <div
              data-title="Validate account"
              style={{
                width: 'clamp(22.5rem, 17rem + 24.44vw, 39rem)',
                padding: '3.125rem 0 0',
                backgroundColor: '#FFFFFF',
                textAlign: 'center',
                boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                borderRadius: '0.25rem',
                overflow: 'hidden',
              }}
            >
              <div data-title="Content" style={{ padding: '0 2rem 0' }}>
                <div data-title="Section Imagotipo" style={{ padding: '0 auto' }}>
                  <div data-title="Isologo" style={{ margin: '20px auto 30px auto', width: 'fit-content' }}>
                    <picture>
                      <img src="/img/FooterBackground.png" alt="Logo Match4Room" width="212" />
                    </picture>
                  </div>
                </div>

                <div data-title="Divider" style={{ height: '0.0625rem', background: '#C0C0C0', textAlign: 'center' }}></div>

                <div data-title="Section de">
                  <div
                    data-title="div contact"
                    style={{ fontSize: '2rem', fontWeight: 400, color: '#D30D2B', textAlign: 'center', padding: '3rem 0 2rem' }}
                  >
                    Nuevo mensaje de contacto
                  </div>

                  <div
                    data-title="div name and lastname"
                    style={{ fontSize: '0.875rem', fontWeight: 400, color: '#444444', textAlign: 'center', paddingBottom: '2rem', margin: '0 2rem' }}
                  >
                    de: {emailParameters.Name} {emailParameters.LastName}
                  </div>

                  <div
                    data-title="div email"
                    style={{ fontSize: '0.875rem', fontWeight: 400, color: '#444444', textAlign: 'center', paddingBottom: '2rem', margin: '0 2rem' }}
                  >
                    Email de contacto: {emailParameters.Email}
                  </div>
                </div>

                <div
                  data-title="Section Validation"
                  style={{ padding: '2rem 1.5rem', borderRadius: '0.5rem', border: '1px solid #E0E0E0', margin: '0 0 2rem' }}
                >
                  <div
                    data-title="div subject"
                    style={{ fontSize: '0.875rem', fontWeight: 400, color: '#444444', textAlign: 'center', paddingBottom: '2rem', margin: '0 2rem' }}
                  >
                    <strong>Asunto:</strong> {emailParameters.Subject}
                  </div>

                  <div
                    data-title="div message"
                    id="NEpWWdE2"
                    style={{ fontSize: '1.125rem', fontWeight: '700', color: '#444444', textAlign: 'center', paddingBottom: '2rem' }}
                  >
                    <strong>Mensaje:</strong> {emailParameters.Message}
                  </div>
                </div>
              </div>

              <div data-title="Section Footer" style={{ padding: '2rem 0rem', textAlign: 'center', background: '#D30D2B' }}>
                <div data-title="Section Imagotipo" style={{ padding: '0 2rem' }}>
                  <div data-title="Isologo" style={{ margin: '2rem auto', width: 'fit-content' }}>
                    <picture>
                      <img src="/img/" alt="/img/" />
                    </picture>
                  </div>
                </div>

                <div data-title="Section Copyright">
                  <div data-title="div" style={{ color: '#FFFFFF', fontSize: '0.625rem', fontWeight: '700' }}>
                    © 2024 Real Travel, All rights reserved
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    )
  }
  const dispatch = useDispatch()
  const [snackbarError, setsnackbarError] = React.useState(false)
  const [snackbarSuccess, setsnackbarSuccess] = React.useState(false)

  // Theme selection

  //const contactsData = useSelector((state: IState) => state.contacts)

  const suscribe = () => {
    let data = { ...Contactsdata }

    if (!regexName.test(Contactsdata.Name)) {
      seterrorMessage('Ingresa un nombre válido')
      setsnackbarError(true)
      return
    } else if (!regexName.test(Contactsdata.LastName)) {
      seterrorMessage('Ingresa un apellido válido')
      setsnackbarError(true)
      return
    } else if (!regexEmail.test(Contactsdata.Email)) {
      seterrorMessage('Ingresa un email válido')
      setsnackbarError(true)
      return
    } else if (Contactsdata.Subject == '') {
      seterrorMessage('Selecciona un asunto')
      setsnackbarError(true)
      return
    } else if (Contactsdata.Message == '') {
      seterrorMessage('Ingresa un mensaje')
      setsnackbarError(true)
      return
    }

    sendEmail('cofran@aptugo.com', {
      Name: `${Contactsdata.Name}`,
      LastName: `${Contactsdata.LastName}`,
      Email: `${Contactsdata.Email}`,
      Subject: `${Contactsdata.Subject}`,
      Message: `${Contactsdata.Message}`,
    })

    setContactsdata({ ...initialDataContacts })

    new Promise((resolve) => {
      if (data._id) {
        dispatch(editContacts(data as any))
      } else {
        dispatch(addContacts(data as any))
      }
      resolve('ok')
    }).then((result) => {
      setmessageSent(true)
      setsnackbarSuccess(true)
    })
  }

  const regexName = /^[A-Za-z ]{2,}$/

  const regexMessage = /^[A-Za-z ]{30,}$/

  const regexEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}(?:\.[A-Za-z]{2,})?$/

  return (
    <React.Fragment>
      <div className={classes.mainPanel}>
        <div data-title="topPage" className={theme.topPage}>
          <TopPageJoinUs />
        </div>

        <div data-title="div container" className={theme.container}>
          <div data-title="Title  Se real travel rework" className={theme.titleRedRework}>
            <Typography variant="h1">
              <span className={theme.titleRedLigth}>SÉ</span>
              REAL TRAVEL
            </Typography>

            <Typography variant="body1">
              ¿Tienes una experiencia que te gustaría ofrecer a los turistas que visitan tu ciudad? ¡Queremos digitalizar tu negocio o
              emprendimiento! Al ser parte de nuestra red de Comercios, ¡más personas te podrán visitar!
            </Typography>
          </div>

          <div data-title="Nuestros Servicios" className={theme.nuestrosServicios}>
            <div data-title="Celulares" className={theme.swiperPhoneDiv}>
              <div data-title="Title " className={theme.titleWhite}>
                <Typography variant="h1">
                  Experiencia
                  <span className={theme.titleRedLigth}>360º</span>
                </Typography>
              </div>

              <div data-title="Container Celulares" className={theme.swiperPhoneDivContainer}>
                <Hidden lgUp>
                  <Carousel
                    className={theme.carouselCardsInstagram}
                    arrows={false}
                    showDots={true}
                    draggable
                    centerMode={true}
                    infinite={true}
                    swipeable={true}
                    minimumTouchDrag={50}
                    autoPlay={true}
                    autoPlaySpeed={2500}
                    pauseOnHover
                    rtl={false}
                    shouldResetAutoplay
                    renderButtonGroupOutside={false}
                    containerClass={theme.containerWithDots}
                    responsive={{
                      desktop: {
                        breakpoint: {
                          max: 5000,
                          min: 951,
                        },
                        items: 1,
                        slidesToSlide: 1,
                        partialVisibilityGutter: 40,
                      },
                      tablet: {
                        breakpoint: {
                          max: 950,
                          min: 521,
                        },
                        items: 1,
                        slidesToSlide: 1,
                        partialVisibilityGutter: 30,
                      },
                      mobile: {
                        breakpoint: {
                          max: 520,
                          min: 0,
                        },
                        items: 1,
                        slidesToSlide: 1,
                        partialVisibilityGutter: 20,
                      },
                    }}
                  >
                    <div data-title="div mapa" className={theme.eachPhone}>
                      <picture className={theme.swiperSlideImg}>
                        <img src="/img/imgMapa.png" alt="/img/imgMapa.png" width="279" height="593" />
                      </picture>
                      <span className={theme.swiperSlideTextBold}>Descubre las historias locales</span>

                      <span className={theme.swiperSlideText}>
                        La App te cuenta en voz de los locales datos históricos, culturales, anécdotas y curiosidades, con acceso a audios, textos,
                        videos y más.
                      </span>
                    </div>

                    <div data-title="div rutas" className={theme.eachPhone}>
                      <picture className={theme.swiperSlideImg}>
                        <img src="/img/imgRutas.png" alt="/img/imgRutas.png" width="310" height="593" />
                      </picture>
                      <span className={theme.swiperSlideTextBold}>Planifica tus rutas a medida</span>

                      <span className={theme.swiperSlideText}>
                        Elige rutas según tu interés, tiempo de recorrido o cercanía para explorar el destino de forma personalizada.
                      </span>
                    </div>

                    <div data-title="div comercios" className={theme.eachPhone}>
                      <picture className={theme.swiperSlideImg}>
                        <img src="/img/comercio.png" alt="/img/comercio.png" width="279" height="593" />
                      </picture>
                      <span className={theme.swiperSlideTextBold}>Explora el comercio local</span>

                      <span className={theme.swiperSlideText}>
                        Encuentra cafés, tiendas, alojamiento, y más de acuerdo a tu ubicación, con información detallada, horarios y direcciones.
                      </span>
                    </div>
                  </Carousel>
                </Hidden>

                <Hidden lgDown>
                  <div data-title="div mapa" className={theme.eachPhone}>
                    <picture className={theme.swiperSlideImg}>
                      <img src="/img/imgMapa.png" alt="/img/imgMapa.png" width="279" height="593" />
                    </picture>
                    <span className={theme.swiperSlideTextBold}>Descubre las historias locales</span>

                    <span className={theme.swiperSlideText}>
                      La App te cuenta en voz de los locales datos históricos, culturales, anécdotas y curiosidades, con acceso a audios, textos,
                      videos y más.
                    </span>
                  </div>

                  <div data-title="div rutas" className={theme.eachPhone}>
                    <picture className={theme.swiperSlideImg}>
                      <img src="/img/imgRutas.png" alt="/img/imgRutas.png" width="310" height="593" />
                    </picture>
                    <span className={theme.swiperSlideTextBold}>Planifica tus rutas a medida</span>

                    <span className={theme.swiperSlideText}>
                      Elige rutas según tu interés, tiempo de recorrido o cercanía para explorar el destino de forma personalizada.
                    </span>
                  </div>

                  <div data-title="div comercios" className={theme.eachPhone}>
                    <picture className={theme.swiperSlideImg}>
                      <img src="/img/comercio.png" alt="/img/comercio.png" width="279" height="593" />
                    </picture>
                    <span className={theme.swiperSlideTextBold}>Explora el comercio local</span>

                    <span className={theme.swiperSlideText}>
                      Encuentra cafés, tiendas, alojamiento, y más de acuerdo a tu ubicación, con información detallada, horarios y direcciones.
                    </span>
                  </div>
                </Hidden>
              </div>
            </div>

            <Container className={theme.containerServicios} maxWidth="xl">
              <div data-title="Title " className={theme.titleWhite}>
                <Typography variant="h1">
                  <span className={theme.titleRedLigth}>NUESTROS</span>
                  SERVICIOS
                </Typography>
              </div>

              <div data-title="Servicios" className={theme.seccionServicios}>
                <div data-title="div territorios" className={theme.cardServicios}>
                  <NavLink to="/JoinUs#videosDeYT">
                    <picture className={theme.cardServicioImg}>
                      <img src="/img/ServiciosParques.png" alt="/img/ServiciosParques.png" />
                    </picture>
                  </NavLink>

                  <Typography variant="h6">Digitalización de territorios</Typography>

                  <span className={theme.swiperSlideText}>
                    Actualiza tu oficina de información turística con información verificada y actualizada en tiempo real.
                  </span>
                </div>

                <div data-title="div parques" className={theme.cardServicios}>
                  <NavLink to="/JoinUs#videosDeYT">
                    <picture className={theme.cardServiciosImg}>
                      <img src="/img/ServicioTerritorios.png" alt="/img/ServicioTerritorios.png" />
                    </picture>
                  </NavLink>

                  <Typography variant="h6">Digitalización de parques</Typography>

                  <span className={theme.swiperSlideText}>
                    ¡Un QR es suficiente para explorar! Obtén tu mapa 100% personalizado, para que tod@s puedan conocer la atracción que ofreces,
                    incluso a través de audioguía en caso de que sea necesario.
                  </span>
                </div>

                <div data-title="div comercios" className={theme.cardServicios}>
                  <NavLink to="/JoinUs#videosDeYT">
                    <picture className={theme.cardServiciosImg2left}>
                      <img src="/img/ServiciosEventos.png" alt="/img/ServiciosEventos.png" />
                    </picture>
                  </NavLink>

                  <Typography variant="h6">Digitalización de comercio</Typography>

                  <span className={theme.swiperSlideText}>
                    Queremos que tu comercio lo conozcan muchas personas y que muchos visitantes disfruten de la experiencia que ofreces. ¡Consigue
                    mayor visibilidad por medio de Real Travel App!
                  </span>
                </div>

                <div data-title="div Eventos" className={theme.cardServicios}>
                  <NavLink to="/JoinUs#videosDeYT">
                    <picture className={theme.cardServiciosImg2}>
                      <img src="/img/ServiciosComercios.png" alt="/img/ServiciosComercios.png" />
                    </picture>
                  </NavLink>

                  <Typography variant="h6">Digitalización de eventos</Typography>

                  <span className={theme.swiperSlideText}>
                    ¡Queremos que los asistentes a tu evento, vivan una experiencia inolvidable! A través de Real Travel app, puedes poner a
                    disposición el programa, expositores, pre y post tours, comercios asociados y sugerencia de rutas.
                  </span>
                </div>
              </div>
            </Container>

            <div data-title="div" id="videosDeYT" className={theme.containerYoutube}>
              <div data-title="div video youtube" className={theme.joinUsVideo}>
                <YouTube videoId="nyMj4qpykHA" className={theme.videoYT} />
              </div>

              <div data-title="div video youtube" className={theme.joinUsVideo}>
                <YouTube videoId="QN-3s8I55YI" className={theme.videoYT} />
              </div>
            </div>
          </div>

          <div data-title="contactUs" id="contactUs">
            <div data-title="div snackbarError" className={theme.snackbarError}>
              <Snackbar
                open={snackbarError}
                autoHideDuration={3000}
                onClose={(e) => {
                  setsnackbarError(false)
                }}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                <Alert variant="filled" severity="warning">
                  <AlertTitle>{errorMessage}</AlertTitle>
                </Alert>
              </Snackbar>
            </div>

            <div data-title="div snackbarSuccess" className={theme.snackbarSuccess}>
              <Snackbar
                open={snackbarSuccess}
                autoHideDuration={3000}
                onClose={(e) => {
                  setsnackbarSuccess(false)
                }}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                <Alert variant="filled" severity="success">
                  <div data-title="div Snackbar">
                    <div data-title="div textSnackbarSuccess" className={theme.textSnackbarSuccess}>
                      <div data-title="div titleSnackbarSuccess" className={theme.titleSnackbarSuccess}>
                        <Typography variant="h4">¡Mensaje Enviado!</Typography>
                      </div>

                      <div data-title="div bodySnackbarSuccess" className={theme.bodySnackbarSuccess}>
                        <Typography variant="body1">
                          ¡Gracias por conectarte con nosotros! Nuestro equipo revisará tu consulta y te responderá lo antes posible.
                        </Typography>
                      </div>
                    </div>

                    <div data-title="div closeIcon" className={theme.closeIcon} onClick={(e) => setsnackbarSuccess(false)}>
                      <Close color="inherit" sx={{}} />
                    </div>
                  </div>
                </Alert>
              </Snackbar>
            </div>

            <div data-title="Title Contactanos" className={theme.titleRed}>
              <Typography variant="h1" className={theme.titleComoFunciona}>
                <span className={theme.titleComoFunciona}>CONTÁCTANOS</span>
              </Typography>

              <Typography variant="body1">
                En Real Travel, estamos para escucharte. Ya sea que tengas preguntas, necesites ayuda, o simplemente quieras compartir tus
                comentarios, nos encantaría saber de vos.
              </Typography>
            </div>

            <div data-title="Form Contacts " className={theme.divContactForms}>
              <Container className={theme.containerFormContactanos} maxWidth="md">
                <div data-title="Nombre y Apellido" className={theme.contactNameLastname}>
                  <div data-title="Nombre" className={theme.itemField}>
                    <TextField
                      margin="dense"
                      size="medium"
                      label="Ingresa tu nombre"
                      type="text"
                      fullWidth
                      className={theme.fieldhardcord}
                      variant="standard"
                      value={Contactsdata.Name || ''}
                      onChange={handleContactsChange('Name')}
                      error={Contactsdata?.errField === 'Name'}
                      helperText={Contactsdata?.errField === 'Name' && Contactsdata.errMessage}
                    />
                  </div>

                  <div data-title="Apellido" className={theme.itemField}>
                    <TextField
                      margin="dense"
                      size="medium"
                      label="Ingresa tu apellido"
                      type="text"
                      fullWidth
                      className={theme.fieldhardcord}
                      variant="standard"
                      value={Contactsdata.LastName || ''}
                      onChange={handleContactsChange('LastName')}
                      error={Contactsdata?.errField === 'LastName'}
                      helperText={Contactsdata?.errField === 'LastName' && Contactsdata.errMessage}
                    />
                  </div>
                </div>

                <div data-title="Correo Electronico" className={theme.contactEmail}>
                  <TextField
                    margin="dense"
                    size="medium"
                    label="Ingresa tu correo electrónico"
                    type="text"
                    fullWidth
                    className={theme.fieldhardcord}
                    variant="standard"
                    value={Contactsdata.Email || ''}
                    onChange={handleContactsChange('Email')}
                    error={Contactsdata?.errField === 'Email'}
                    helperText={Contactsdata?.errField === 'Email' && Contactsdata.errMessage}
                  />
                </div>

                <div data-title="Asunto del mensaje" className={theme.contactSubject}>
                  <TextField
                    margin="dense"
                    size="medium"
                    label="Asunto del mensaje"
                    type="text"
                    fullWidth
                    className={theme.fieldhardcord}
                    variant="standard"
                    value={Contactsdata.Subject || ''}
                    onChange={handleContactsChange('Subject')}
                    error={Contactsdata?.errField === 'Subject'}
                    helperText={Contactsdata?.errField === 'Subject' && Contactsdata.errMessage}
                  />
                </div>

                <div data-title="Mensaje" className={theme.contactMessage}>
                  <TextField
                    variant="standard"
                    margin="normal"
                    size="small"
                    label="Ingresa tu mensaje"
                    className={theme.fieldhardcordMensaje}
                    multiline
                    type="text"
                    fullWidth
                    value={Contactsdata.Message || ''}
                    onChange={(e) => {
                      setContactsdata({ ...Contactsdata, Message: e.target.value })
                    }}
                  />
                </div>

                <Button
                  color="primary"
                  onClickCapture={(e) => {
                    suscribe()
                  }}
                  className={theme.contactButtonSend}
                  disabled={messageSent}
                >
                  Enviar mensaje
                </Button>
              </Container>
            </div>
          </div>

          <div data-title="div contact icons" className={theme.divIconContacts}>
            <div data-title="div Icons Contacts  Location" className={theme.iconsContacts}>
              <picture>
                <img src="/img/iconPin.png" alt="/img/iconPin.png" />
              </picture>

              <Typography variant="h6">Ubicación</Typography>

              <Typography variant="body1" className={theme.pLocation}>
                San ignacio 879, Puerto Varas, Chile
              </Typography>
            </div>

            <div data-title="div Icons Contacts  phone" className={theme.iconsContacts}>
              <picture>
                <img src="/img/iconPhone.png" alt="/img/iconPhone.png" />
              </picture>

              <Typography variant="h6">Teléfono</Typography>

              <Typography variant="body1" className={theme.typoNumFlag}>
                <picture className={theme.typoFlag}>
                  <img src="/img/banderaChile.jpg" alt="/img/banderaChile.jpg" width="15" height="15" />
                </picture>
                +56984531583
              </Typography>

              <Typography variant="body1" className={theme.typoNumFlag}>
                <picture className={theme.typoFlag}>
                  <img src="/img/banderaCostaRica.png" alt="/img/banderaCostaRica.png" width="15" height="15" />
                </picture>
                +50672993389
              </Typography>
            </div>

            <div data-title="div Icons Contacts  Email" className={theme.iconsContacts}>
              <picture>
                <img src="/img/iconEmail.png" alt="/img/iconEmail.png" />
              </picture>

              <Typography variant="h6">Email</Typography>

              <Typography variant="body1">hola@realtravel.cl</Typography>
            </div>
          </div>
        </div>
      </div>

      <div data-title="Footer Red" className={theme.footersRed}>
        <div data-title="div footer Left" className={theme.footerDivLeft}>
          <div data-title="div Img And Buttons Socials" className={theme.footerImgSocials}>
            <div data-title="div Img" className={theme.footerImg}>
              <picture>
                <img src="/img/RTLogo_blanco.svg" alt="/img/RTLogo_blanco.svg" />
              </picture>
            </div>

            <div data-title="div buttons socials" className={theme.footerButtonsSocials}>
              <a target="_blank" href="https://www.linkedin.com/company/realtravel/">
                <picture>
                  <img src="/img/LogoLinkedin.svg" alt="/img/LogoLinkedin.svg" />
                </picture>
              </a>

              <a href="mailto:hola@realtravel.cl?subject=Email%20de%20contacto%20por%20&body=Hola!%20Me%20contacto%20desde%20el%20website%20de%20Real%20Travel%20para%3A%20">
                <picture>
                  <img src="/img/LogoMail.svg" alt="/img/LogoMail.svg" />
                </picture>
              </a>

              <a target="_blank" href="https://www.instagram.com/realtravelap/">
                <picture>
                  <img src="/img/LogoIntagram.svg" alt="/img/LogoIntagram.svg" />
                </picture>
              </a>

              <a target="_blank" href="https://www.youtube.com/channel/UC535xN03fixDzJGFtVDAtvA/featured">
                <picture>
                  <img src="/img/logoYouTube.svg" alt="/img/logoYouTube.svg" />
                </picture>
              </a>
            </div>
          </div>

          <div data-title="div All rights reserved" className={theme.footerAllRightsReserved}>
            <Typography variant="body1">©2024 Real Travel. All rights reserved</Typography>
          </div>
        </div>

        <div data-title="div links" className={theme.footerDivCenter}>
          <NavLink to="/AboutUs">
            <Typography variant="h6">Quienes somos</Typography>
          </NavLink>

          <NavLink to="/JoinUs">
            <Typography variant="h6">Se parte</Typography>
          </NavLink>

          <NavLink to="/Press">
            <Typography variant="h6">Prensa</Typography>
          </NavLink>
        </div>

        <div data-title="Div Footer  Right" className={theme.footerDivRight}>
          <div data-title="div terms and conditions" className={theme.footerTermsAndConditions}>
            <NavLink to="/TermsAndConditions">
              <Typography variant="body1">Términos y condiciones</Typography>
            </NavLink>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default JoinUs
